import { render, staticRenderFns } from "./HotelReservationInternalNotes.vue?vue&type=template&id=79e45fcc&"
import script from "./HotelReservationInternalNotes.vue?vue&type=script&lang=js&"
export * from "./HotelReservationInternalNotes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/live/admin/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('79e45fcc')) {
      api.createRecord('79e45fcc', component.options)
    } else {
      api.reload('79e45fcc', component.options)
    }
    module.hot.accept("./HotelReservationInternalNotes.vue?vue&type=template&id=79e45fcc&", function () {
      api.rerender('79e45fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/bespoke/reservationAdministration/HotelReservationInternalNotes.vue"
export default component.exports